import styled from "styled-components";
import { P, Box, Icon } from "@eriksdigital/atomic-ui/components";
import {
  colors,
  spacing,
  fonts,
  breakpoints,
} from "@eriksdigital/atomic-ui/styles";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: ${spacing.sp16};

  ${breakpoints.tabletLandscape`
    flex-direction: row;
    padding: ${spacing.sp32};
  `}
`;

export const TextWrapper = styled.div`
  margin-left: ${spacing.sp32};
`;

export const Title = styled.div`
  color: ${colors.text.tertiary};
  font-size: ${fonts.fontSize.ft16};
  font-weight: ${fonts.fontWeight.medium};
  margin-bottom: ${spacing.sp12};

  ${breakpoints.tabletLandscape`
    font-size: ${fonts.fontSize.ft16};
    font-weight: ${fonts.fontWeight.medium}; 
  `}
`;
export const EriksNumber = styled(P)`
  font-size: ${fonts.fontSize.ft16};
  color: ${colors.text.darkGray};

  ${breakpoints.tabletLandscape`
    font-size: ${fonts.fontSize.ft16};
  `}
`;

export const DeliveryDate = styled.span`
  color: ${colors.text.complementary};
  font-size: ${fonts.fontSize.ft16};
  margin-bottom: ${spacing.sp8};

  ${breakpoints.tabletLandscape`
    margin-bottom: 0;
  `}
`;

export const MainBlock = styled(Box)`
  width: 100%;
  ${breakpoints.tabletLandscape`
    width: 40%;
  `}
`;

export const PriceBlock = styled(Box)`
  width: 100%;
  ${breakpoints.tabletLandscape`
    width: auto;  
  `}
`;

export const NoPriceMessage = styled(Box)`
  width: 100%;
  ${breakpoints.tabletLandscape`
    width: 60%;
  `}
`;

export const StyledIcon = styled(Icon)`
  color: ${colors.default.blueD};
  vertical-align: middle;
  height: ${spacing.sp16};
  width: ${spacing.sp16};
`;

export const PriceNumber = styled.span`
  color: ${colors.text.secondary};
`;

export const Text = styled.span`
  color: ${colors.default.red};
`;
